export default __webpack_public_path__ + "static/media/apps.574428f3.svg";